import { Typography } from "@mui/material";
import WidgetCard from "@arelia-components/ui-atoms/WidgetCard";
import { formatCurrency } from "@arelia-utils/helpers/formatCurrency";
import calcDifference from "@arelia-utils/helpers/calcDifference";
import { ChangeCardStatus } from "@arelia-components/ui-atoms/ChangeCardStatus";
import { TotalMonth, TotalYear } from "./earnings-per-period.models";

type Props = {
  earnings: TotalMonth | TotalYear;
  timespan: string;
  loading: boolean;
  error: boolean;
  widgetId: string;
};

export default function EarningsPerPeriodPresenter({ earnings, loading, error, widgetId, timespan }: Props) {
  const currEarnings = "thisMonth" in earnings ? earnings.thisMonth : earnings.thisYear;
  const lastEarnings = "lastMonth" in earnings ? earnings.lastMonth : earnings.lastYear;
  const growth = calcDifference(currEarnings, lastEarnings);

  return (
    <WidgetCard
      widgetId={widgetId}
      title={`This ${timespan}`}
      loading={loading}
      error={error}
    >
      <Typography variant="h2">{formatCurrency(currEarnings)}</Typography>
      <ChangeCardStatus change={growth} timespan={timespan}/>
    </WidgetCard>
  );
}
